import { Button } from '@/components/Button/Button';
import { Modal } from '@/components/Modal/Modal';
import { Tenant } from '@/server/api/schemas/tenant.types';
import { useLocale, useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export const TenantCheck = ({ tenant }: { tenant?: Tenant | null }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const t = useTranslations();
  const locale = useLocale();

  useEffect(() => {
    if (!tenant) {
      return;
    }

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'activeTenant') {
        const activeTenant = JSON.parse(event.newValue ?? '{}') as Tenant;

        if (activeTenant.id !== tenant.id) {
          setShowOverlay(true);
        } else {
          setShowOverlay(false);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [tenant]);

  const handleClose = () => {
    window.location.href = `/${locale}/customer`;
  };

  if (!tenant) {
    return null;
  }

  return (
    <Modal open={showOverlay} onClose={handleClose}>
      <div className="flex h-full flex-col items-center justify-center gap-400">
        <h1 className="headline-small font-bold">{t('tenantCheck_title')}</h1>
        <p>{t('tenantCheck_description')}</p>
        <Button onClick={handleClose}>{t('common_close')}</Button>
      </div>
    </Modal>
  );
};
